var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowSelectTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 8a6.674 6.674 0 01-6.666 6.667A6.674 6.674 0 011.334 8a6.674 6.674 0 016.667-6.667A6.674 6.674 0 0114.667 8",
    stroke: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.814 7.038a.498.498 0 01-.146.353L8.355 9.715a.501.501 0 01-.709 0L5.331 7.391a.5.5 0 11.709-.706L8 8.655l1.96-1.97a.5.5 0 01.854.353z",
    fill: "#ED1B2E"
  })));
}

export default SvgArrowSelectTable;